import React, { PropTypes } from "react";
import * as pathConsts from "../../constants/pathConstants";
import DashboardOptionButton from "./DashboardOptionButton";
import "../../styles/dashboard/dashboardOptions.css";
import ReactTooltip from "react-tooltip";
import { Glyphicon } from "react-bootstrap";

const DashboardOptions = ({ onClick }) => {
  return (
    <div className="col-sm-6 col-xs-12 getting-started-links">
      <div id="dashboard-options-container">
        <div className="manual-entry-container">
          <h3>
            Enter Data with our Online Form
            <span className="tooltip-container">
              <Glyphicon
                glyph="info-sign"
                className="span-tooltip"
                data-tip
                data-for="manual-data-entry"
              />
              <ReactTooltip
                id="manual-data-entry"
                place="right"
                type="dark"
                effect="float"
              >
                Use this method to enter and submit your data through this web
                portal by manually entering your data into the webforms. This is
                recommended for small amounts of data.
              </ReactTooltip>
            </span>
          </h3>
          <div className="dashboard-button-container">
            <DashboardOptionButton
              text="Create Establishment"
              path={pathConsts.pathToCreateEstablishmentPage}
              helpText={
                <div>
                  {" "}
                  <b>Add a new establishment</b> to your account
                </div>
              }
              onClick={onClick}
            />
            <DashboardOptionButton
              text="View Establishment List"
              outlinedButton={true}
              path={pathConsts.pathToEstablishmentsDashboardPage}
              helpText={
                <div>
                  {" "}
                  <b>View existing establishments</b> and add or edit data
                </div>
              }
              onClick={onClick}
            />
          </div>
        </div>
        <div className="batch-entry-container">
          <h3>
            Multiple Establishments? Upload your Data Here
            <span className="tooltip-container">
              <Glyphicon
                glyph="info-sign"
                className="span-tooltip"
                data-tip
                data-for="batch-entry"
              />
              <ReactTooltip
                id="batch-entry"
                place="right"
                type="dark"
                effect="float"
              >
                Use this method to upload or transmit large amounts of data.
                Your data will be considered submitted upon successful
                processing of your file or transmission.
              </ReactTooltip>
            </span>
          </h3>
          <div className="dashboard-button-container">
            <DashboardOptionButton
              text="Upload 300A Data"
              path={pathConsts.pathToFileUploadForm}
              helpText={
                <div>
                  {" "}
                  <b>For multiple establishments</b>, upload your CSV file containing
                  your 300A summary data{" "}
                </div>
              }
              onClick={onClick}
            />
            <DashboardOptionButton
              text="Upload 300/301 Data"
              path={pathConsts.pathToCaseDataFileUploadForm}
              helpText={
                <div>
                  {" "}
                  <b>For multiple cases</b>, upload your CSV file containing your
                  300/301 case data{" "}
                </div>
              }
              onClick={onClick}
            />
            <DashboardOptionButton
              text="View Your API Token"
              outlinedButton={true}
              path={pathConsts.accountPageBase + pathConsts.pathToApiTokenPage}
              helpText={
                <div>
                  {" "}
                  <b>Access your authentication token</b> for use in
                  electronically transmitting data via API{" "}
                </div>
              }
              onClick={onClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardOptions.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default DashboardOptions;



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/DashBoardOptions.js
 **/